// checkout/utils/toggleLoadingSpinner.ts

/**
 * Toggles a loading spinner inside a specified container.
 *
 * If a loading spinner already exists, it is removed. Otherwise, a new spinner element
 * is created and appended to the specified container.
 *
 * @param {HTMLElement} container - The target container to inject the spinning element into.
 * @param {string} spinnerText - The text to sit underneath the spinning animation.
 */
export function toggleLoadingSpinner(container: HTMLElement, spinnerText: string | null): void {
	const spinner = container.querySelector('.checkout__loading');
	if (spinner) return spinner.remove();
	const loadingElem = document.createElement('div');
	loadingElem.classList.add('checkout__loading');
	if (spinnerText) loadingElem.dataset.spinnerText = spinnerText;
	container.appendChild(loadingElem);
}
